export const small_phone_breakpoint = "(max-width: 320px)";
export const landscap_mobile_breakpoint = "(max-width: 480px)";
export const mobile_breakpoint = "(max-width: 600px)";
export const custome_breakpoint = "(max-width: 625px)";
export const tablet_breakpoint = "(min-width: 601px) and (max-width: 1024px)";
export const laptop_breakpoint = "(min-width: 1025px)";